import React, {useEffect, useState} from "react";
import {useGlobal} from "../../Store";
import {Link} from "react-router-dom";
import {postData} from "../../Utils/Server";
import Endpoints from "../../Constants/Endpoints";
import {ERROR, Notify, SUCCESS} from "../../Utils/Notify";
import {goToPage, updateDocumentTitle} from "../../Utils/Common";
import {useHistory} from "react-router-dom";
import PageLayout from "../Layout/PageLayout";
import {Button, Card, CardTitleBar, CardBody, FormField, TextInput} from "../UI";

const Receive = props => {

    let history = useHistory();
    const [globalState, globalActions] = useGlobal();
    const [isLoading, setIsLoading] = useState(false);
    const [code, setCode] = useState('');

    useEffect(() => {
        updateDocumentTitle("Receive goods")
    }, []);

    const receiveGoods = e => {
        e.preventDefault();

        let data = new FormData();
        data.append("code", code)

        setIsLoading(true);

        postData(Endpoints.REQUEST_RECEIVE, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                if (res.success === 1) {
                    setCode('');
                    Notify(res.data, SUCCESS);
                    goToPage(history, "/requests/cc")
                } else {
                    if (Array.isArray(res.message)) {
                        Notify(res.message[0], ERROR);
                    } else {
                        Notify(res.message, ERROR);
                    }
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }


    return (
        <PageLayout
            title="Receive goods at call centre"
            actions={
                <Link to="/requests">
                    <Button variant="outline">Back to requests</Button>
                </Link>
            }
        >
            <Card padded={false} style={{maxWidth: 560}}>
                <CardTitleBar title="Enter request code here"/>
                <CardBody>
                    <form>
                        <FormField label="Request code" htmlFor="receiveCode">
                            <TextInput
                                id="receiveCode"
                                type="text"
                                required={true}
                                placeholder="Code"
                                value={code}
                                onChange={e => setCode(e.target.value)}
                            />
                        </FormField>
                        <Button
                            type="submit"
                            loading={isLoading}
                            onClick={e => receiveGoods(e)}
                        >
                            Receive
                        </Button>
                    </form>
                </CardBody>
            </Card>
        </PageLayout>
    )
};

export default Receive;
